import VueRouter from 'vue-router'

import routes from '@/routes/routes'

const router = new VueRouter({
    routes
})

export default router